import { RootStateOrAny, shallowEqual, useSelector } from 'react-redux';
import { useMemo } from 'react';
import { UserRole } from '../types';

const useIsDoctorRole = (): boolean => {
  const role = useSelector((state: RootStateOrAny) => state.auth.role, shallowEqual);
  return useMemo(() => role === UserRole.DOCTOR, [role]);
};
export default useIsDoctorRole;
